import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ resizable: _ctx.minLines === 0 })
  }, [
    _createElementVNode("div", {
      id: _ctx.identifier,
      ref: "root"
    }, null, 8, _hoisted_1)
  ], 2))
}